import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=1f05903c&scoped=true&"
import script from "./ResultsView.vue?vue&type=script&lang=js&"
export * from "./ResultsView.vue?vue&type=script&lang=js&"
import style0 from "./ResultsView.vue?vue&type=style&index=0&id=1f05903c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05903c",
  null
  
)

export default component.exports